import { AddressList } from './AddressList'
import { MapContainer } from './MapContainer'


export const Component = { AddressList, MapContainer }